import template from './AssignPublishedVersionNameModalView.html';
import controller from './AssignPublishedVersionNameModalController';
export default (params) => {
    return {
        template,
        controller,
        controllerAs: '$ctrl',
        ...params,
        inputs: {
            ...params.inputs,
            title: params.title,
            description: params.description,
            confirm: params.confirm,
        },
    };
};
